const openingSpecialPopup = document.querySelector('.opening-special-popup');
const openingSpecialBadge = document.querySelector('.opening-special-badge');

if (openingSpecialPopup && openingSpecialBadge) {
    const closeOpeningSpecialPopup = openingSpecialPopup.querySelector('.opening-special-popup__close');
    const copyCodeButton = openingSpecialPopup.querySelector('.opening-special-popup__button');

    openingSpecialBadge.addEventListener('click', () => {
        openingSpecialPopup.showModal();
    });

    if (closeOpeningSpecialPopup) {
        closeOpeningSpecialPopup.addEventListener('click', () => {
            openingSpecialPopup.close();
        });
    }

    if (copyCodeButton && navigator.clipboard) {
        copyCodeButton.addEventListener('click', () => {
            navigator.clipboard.writeText('OPENING1643');
        });
    }
}
